import React from 'react';
import { ElementImageIcon } from 'src/components/ElementImageIcon/ElementImageIcon';
import * as styles from './ElementCard.module.scss';

export const ElementCard = ({ icon, title, description, cardStyle }) => (
  <div className={`${styles.card} ${cardStyle} rounded-2xl p-4`}>
    <div className="mb-6">
      <ElementImageIcon icon={icon} />
    </div>

    <div>
      <div className="font-weight-bold rfs-size-3xl">{title}</div>
      <div className="font-weight-bold">{description}</div>
    </div>
  </div>
);
